export default [
  {
    title: 'Tags',
    icon: 'mdi-tag',
    to: 'MemberTagSetting',
    keywords: ['แท็กสมาชิก', 'ป้ายลูกค้า', 'member', 'tag']
  }
]
